import React from "react";

interface FundingProps extends React.SVGProps<SVGSVGElement> {
  id?: string;
  isActive?: boolean;
}

const FundingIcon: React.FC<FundingProps> = ({
  fill = "#fff",
  id = React.useId(),
  isActive = false,
  ...props
}) => (
  <svg
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 345.72 386.83"
    fill={fill}
    id={`funding-svg-${id}`}
    {...props}
  >
    <defs>
      <style>{`.uuid-5e2d547c-7960-4ca5-b165-946ebf3807eb { fill: ${fill}; }`}</style>
    </defs>
    <g id={`layer1-${id}`} data-name="Layer 1">
      <g
        id={`funding-group-${id}`}
        data-name="14-Funding"
        filter={isActive ? "url(#fundingFilter)" : undefined}
      >
        <path
          id={`path1-${id}`}
          d="M172.86,24c2.8,0,5.57.74,8,2.14l132.86,76.71c4.93,2.85,8,8.16,8,13.86v153.42c0,5.7-3.07,11.01-8,13.86l-132.86,76.71c-2.43,1.4-5.2,2.14-8,2.14s-5.57-.74-8-2.14L32,283.98c-4.93-2.85-8-8.16-8-13.86V116.71c0-5.7,3.07-11.01,8-13.86L164.86,26.14c2.43-1.4,5.2-2.14,8-2.14M172.86,0c-6.91,0-13.81,1.79-20,5.36L20,82.07C7.62,89.21,0,102.42,0,116.71v153.42c0,14.29,7.62,27.5,20,34.64l132.86,76.71c6.19,3.57,13.09,5.36,20,5.36s13.81-1.79,20-5.36l132.86-76.71c12.38-7.15,20-20.35,20-34.64V116.71c0-14.29-7.62-27.5-20-34.64L192.86,5.36c-6.19-3.57-13.09-5.36-20-5.36h0Z"
        />
        <path
          id={`path2-${id}`}
          d="M222.9,221.81c0,6.6-1.17,12.55-3.51,17.85-2.34,5.3-5.66,9.87-9.96,13.7-4.3,3.84-9.48,6.91-15.55,9.21-6.07,2.3-12.79,3.76-20.16,4.38l-2.42,24.65c-.08.61-.25,1.15-.52,1.61-.27.46-.77.85-1.5,1.15s-1.73.56-2.99.75c-1.27.19-2.86.29-4.78.29-2.46,0-4.43-.12-5.93-.34-1.5-.23-2.67-.56-3.51-.98-.85-.42-1.4-.98-1.67-1.67-.27-.69-.33-1.46-.17-2.3l2.42-23.38c-3.3-.46-6.41-1.06-9.33-1.79-2.92-.73-5.57-1.53-7.95-2.42-2.38-.88-4.43-1.79-6.16-2.71-1.73-.92-3.03-1.82-3.92-2.71-.88-.88-1.52-2.19-1.9-3.92-.39-1.73-.58-4.28-.58-7.66,0-2.61.08-4.76.23-6.45.15-1.69.42-3,.81-3.92.38-.92.86-1.55,1.44-1.9.58-.34,1.25-.52,2.01-.52,1,0,2.46.58,4.38,1.73,1.92,1.15,4.38,2.42,7.37,3.8,2.99,1.38,6.62,2.65,10.88,3.8s9.27,1.73,15.03,1.73c8.98,0,15.66-1.67,20.04-5.01,4.38-3.34,6.56-7.77,6.56-13.3,0-3.69-.94-6.72-2.82-9.1-1.88-2.38-4.4-4.47-7.54-6.28-3.15-1.8-6.7-3.42-10.65-4.84-3.96-1.42-8.01-2.94-12.15-4.55-4.15-1.61-8.2-3.49-12.15-5.64-3.96-2.15-7.51-4.8-10.65-7.95-3.15-3.15-5.66-6.97-7.54-11.46s-2.82-9.92-2.82-16.3c0-5.76.96-11,2.88-15.72,1.92-4.72,4.68-8.85,8.29-12.38,3.61-3.53,8.04-6.39,13.3-8.58,5.26-2.19,11.23-3.67,17.91-4.43l2.3-23.15c.08-.61.25-1.13.52-1.55.27-.42.77-.81,1.5-1.15.73-.35,1.71-.59,2.94-.75,1.23-.15,2.84-.23,4.84-.23,2.38,0,4.36.12,5.93.35s2.78.56,3.63.98c.84.42,1.38.98,1.61,1.67s.35,1.46.35,2.3l-2.3,21.77c2.15.31,4.41.73,6.8,1.27,2.38.54,4.61,1.17,6.68,1.9,2.07.73,3.95,1.5,5.64,2.3s2.86,1.54,3.51,2.19c.65.65,1.15,1.31,1.5,1.96.34.65.61,1.46.81,2.42.19.96.33,2.11.4,3.45.08,1.34.12,2.9.12,4.66,0,2.38-.06,4.34-.17,5.88-.11,1.54-.33,2.71-.63,3.51-.31.81-.65,1.34-1.04,1.61-.39.27-.85.4-1.38.4-1,0-2.46-.5-4.38-1.5-1.92-1-4.28-2.07-7.08-3.22-2.8-1.15-6.03-2.23-9.67-3.22-3.65-1-7.66-1.5-12.04-1.5-3.99,0-7.41.39-10.25,1.15-2.84.77-5.15,1.84-6.91,3.22-1.77,1.38-3.07,3.04-3.92,4.95-.85,1.92-1.27,4.03-1.27,6.34,0,3.61.96,6.64,2.88,9.1,1.92,2.46,4.47,4.57,7.66,6.33,3.19,1.77,6.8,3.38,10.83,4.84,4.03,1.46,8.14,2.99,12.32,4.61,4.18,1.61,8.29,3.48,12.32,5.59,4.03,2.11,7.62,4.72,10.77,7.83,3.15,3.11,5.68,6.87,7.6,11.29,1.92,4.42,2.88,9.73,2.88,15.95Z"
        />
      </g>
    </g>
    {isActive && (
      <defs>
        <filter
          id="fundingFilter"
          x="-100%"
          y="-100%"
          width="500%"
          height="500%"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0823529 0 0 0 0 0.505882 0 0 0 0 0.929412 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1" result="shape" />
        </filter>
      </defs>
    )}
  </svg>
);

export default FundingIcon;
